@if (authService.isAuthLoading()) {
    <si-loading-spinner
        [isBlockingSpinner]="true"
        [isSpinnerOverlay]="true"
        [ariaLabel]="'accessibility.loading-application' | translate"
    />
}

@if (isRouterPathUnauthorized()) {
    <div class="h-screen">
        <router-outlet />
    </div>
} @else {
    <div class="lay-wrapper lay-wrapper--header">
        <app-header></app-header>
    </div>
    <div class="lay-wrapper lay-wrapper--main" [ngClass]="{ ready: tenantAuthorizationService.activeTenantRole() }">
        <div class="lay-wrapper lay-wrapper--content">
            @if (tenantAuthorizationService.activeTenantRole()) {
                <div class="navigation-container">
                    <si-navbar-vertical
                        navbarCollapseButtonText="collapse"
                        navbarExpandButtonText="expand"
                        [items]="tabs"
                    ></si-navbar-vertical>
                </div>
            }
            <div class="outlet">
                @if (tenantAuthorizationService.activeTenantRole()) {
                    <div class="search-box-container">
                        <app-search-box></app-search-box>
                    </div>
                }
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
    @if (!isBottomNavExpanded) {
        <button
            type="button"
            [ngClass]="{ 'contacts-visible-none-or-absolute': isBottomVisible }"
            class="visible-contacts"
            [attr.aria-label]="'accessibility.open-contacts' | translate"
            (click)="scrollToBottom(); (isBottomVisible)"
        >
            <div class="content">
                <div class="content__container">
                    <ul class="content__container__list">
                        <li class="content__container__list__item">{{ 'buttonContact' | translate }}</li>
                    </ul>
                </div>
            </div>
        </button>
    }
    <div class="lay-wrapper lay-wrapper--bottom-nav" id="lay-wrapper-bottom-nav-section">
        <app-bottom-navigation (expandedChange)="isBottomNavExpanded = $event"></app-bottom-navigation>
    </div>
    <div class="lay-wrapper lay-wrapper--footer">
        <si-footer id="lay-wrapper-footer-section" [copyright]="footerCopyright" [links]="footerLinks" />
    </div>
}
